import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";

export const createRate = createAsyncThunk(
  ActionTypes.CREATE_RATES,
  async (rateData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "rate/create",
        "post",
        rateData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
); 
export const updateRate = createAsyncThunk(
  ActionTypes.UPDATE_RATES,
  async (rateData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "rate/update",
        "patch",
        rateData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getRate = createAsyncThunk(
  ActionTypes.GET_Rate,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `rate/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
); 

export const createBoxRate = createAsyncThunk(
  ActionTypes.CREATE_BOX_RATES,
  async (rateBoxData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "box-rate/create",
        "post",
        rateBoxData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
); 
export const updateBoxRate = createAsyncThunk(
  ActionTypes.UPDATE_BOX_RATES,
  async (rateBoxData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "box-rate/update",
        "patch",
        rateBoxData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getBoxRate = createAsyncThunk(
  ActionTypes.GET_BOX_Rate,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `box-rate/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
); 

export const createInsurance = createAsyncThunk(
  ActionTypes.CREATE_INSURANCE,
  async (insuranceData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "insurance/create",
        "post",
        insuranceData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateInsurance = createAsyncThunk(
  ActionTypes.UPDATE_INSURANCE,
  async (insuranceData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "insurance/update",
        "patch",
        insuranceData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getInsurance = createAsyncThunk(
  ActionTypes.GET_INSURANCE,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `insurance/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createTimeSlot = createAsyncThunk(
  ActionTypes.CREATE_TIME_SLOT,
  async (timeSlotData: any,{ rejectWithValue }) => {
    try {
      const res = await apiCall(
       "timeslot/create",
        "post",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateTimeSlot = createAsyncThunk(
  ActionTypes.UPDATE_TIME_SLOT,
  async (timeSlotData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       "timeslot/update",
        "patch",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const deleteTimeSlot = createAsyncThunk(
  ActionTypes.DELETE_TIME_SLOT,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `timeslot/delete/${id}`,
        "delete"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getTimeSlot = createAsyncThunk(
  ActionTypes.GET_TIME_SLOT,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `timeslot/carrier/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const createTravelTime = createAsyncThunk(
  ActionTypes.CREATE_TRAVEL_TIME,
  async (timeSlotData: any,{ rejectWithValue }) => {
    try {
      const res = await apiCall(
       "travel-time/create",
        "post",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateTravelTime = createAsyncThunk(
  ActionTypes.UPDATE_TRAVEL_TIME,
  async (timeSlotData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       "travel-time/update",
        "patch",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getTravelTime = createAsyncThunk(
  ActionTypes.GET_TRAVEL_TIME,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `travel-time/carrier/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createLongDistance = createAsyncThunk(
  ActionTypes.CREATE_LONG_DISTANCE,
  async (timeSlotData: any,{ rejectWithValue }) => {
    try {
      const res = await apiCall(
       "long-distance/create",
        "post",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateLongDistance = createAsyncThunk(
  ActionTypes.UPDATE_LONG_DISTANCE,
  async (timeSlotData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       "long-distance/update",
        "patch",
        timeSlotData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getLongDistance = createAsyncThunk(
  ActionTypes.GET_LONG_DISTANCE,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `long-distance/carrier/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteLongDistance = createAsyncThunk(
  ActionTypes.DELETE_LONG_DISTANCE,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `long-distance/delete/${id}`,
        "delete"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getLocations = createAsyncThunk(
  ActionTypes.GET_LOCATION,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `location/carrier/${id}`,
        "get",
        id
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createLocation = createAsyncThunk(
  ActionTypes.CREATE_LOCATION,
  async (data: any,{ rejectWithValue }) => {
    try {
      const res = await apiCall(
       "location/create",
        "post",
        data
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateLocation = createAsyncThunk(
  ActionTypes.UPDATE_LOCATION,
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       "location/update",
        "patch",
        data
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const deleteLocation = createAsyncThunk(
  ActionTypes.DELETE_LOCATION,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
       `location/delete/${id}`,
        "delete"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);